import { render, staticRenderFns } from "./TabelaPagamento.vue?vue&type=template&id=f2229898&scoped=true&"
import script from "./TabelaPagamento.vue?vue&type=script&lang=js&"
export * from "./TabelaPagamento.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPagamento.vue?vue&type=style&index=0&id=f2229898&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2229898",
  null
  
)

export default component.exports